import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {InvoiceDealer} from '../../../Models/InvoiceDealer';
import {Grid, GridSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {DealersService} from '../../../Services/dealers.service';
import {UserTerm} from '../../../Models/UserTerm';
import {IButton} from '../../../../shared/card/card.component';


@Component({
  selector: 'app-dealer-overview',
  templateUrl: './dealer-overview.component.html',
  styleUrls: ['./dealer-overview.component.scss']
})
export class DealerOverviewComponent implements OnInit {

  public grid: Grid;
  public dealerId: number;
  public companyName: string;
  public advancedButtons: IButton[] = [];
  public syncButton;

  @ViewChild('usersRowDetail', {static: false}) usersRowDetail: any;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(private router: Router, private dealersService: DealersService, private translateService: TranslateService,
              private broadCastService: BroadcastService) {
  }

  ngOnInit() {

    this.syncButton = {
      key: 'sync',
      btnName: this.translateService.instant('admin.exact.sync'),
      method: 'syncWithExact',
      btnCustomClass: 'btn-primary',
      btnIcon: 'fa fa-repeat'
    };

    this.advancedButtons.push(this.syncButton);

    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.invoice_dealer.dealer_number',
          prop: 'debtor',
          sortable: true,
          type: TextColumn.type,
          width: 130,
          minWidth: 130,
          maxWidth: 130,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.companyName',
          prop: 'companyName',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.contact',
          prop: 'contact',
          sortable: true,
          type: TextColumn.type,
          width: 150,
          minWidth: 130,
          maxWidth: 250,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.email',
          prop: 'companyEmail',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.phone',
          prop: 'phone',
          sortable: true,
          type: TextColumn.type,
          width: 130,
          minWidth: 130,
          maxWidth: 200,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.term_status',
          prop: 'termStatus',
          sortable: true,
          type: TextColumn.type,
          width: 120,
          minWidth: 120,
          maxWidth: 120,
          translate: true,
          valueFormatter: (row: UserTerm[]) => {
            if (row.length > 0) {
              return this.translateService.instant('doctrine.user_term.statuses.' + row);
            }
            return '-';
          }
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          width: 80,
          minWidth: 80,
          maxWidth: 80,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case InvoiceDealer.INVOICEDEALER_ACTIVE:
                return this.translateService.instant('global.active');
              case InvoiceDealer.INVOICEDEALER_ON_HOLD:
                return this.translateService.instant('global.status_on_hold');
              case InvoiceDealer.INVOICEDEALER_INACTIVE:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <ActionColumn>{
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('back-office/crm/dealer/' + row.id + '/show'),
              showCallback: row => row,
              btnClass: 'ripple light '
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.dealerId = row.id;
                this.companyName = row.companyName.bold();
                this.deleteModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        }
      ],
      service: this.dealersService,
      rememberURL: this.router.url,
      method: 'getDealers',
      defaultSort: 'debtor',
      rowDetailTemplate: this.usersRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          hasDropdownListFilter: true,
          hasNormalSearch: true
        },
      ],
    };
  }

  softDelete() {
    this.dealersService.softDeleteDealer(this.dealerId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadCastService.broadcast('refreshGrid', 'getDealers');
    });
  }

  goToArchive() {
    this.router.navigateByUrl('back-office/crm/dealer/archive');
  }

  // syncWithExact() {
  //   this.syncButton.btnCustomClass = 'btn-grey working';
  //   this.dealersService.sync().subscribe((res) => {
  //     this.syncButton.btnCustomClass = 'btn-primary';
  //     this.broadCastService.broadcast('refreshGrid', 'getDealers');
  //   }, (e) => {
  //     this.syncButton.btnCustomClass = 'btn-primary';
  //   });
  // }

  calFunction(method: string) {
    this[method]();
  }

}
